import { Button, Count, Box, Icon } from '@vp/swan';
import React, { useState, useContext, useEffect, useCallback } from 'react';
import { CAContext } from './src-contexts-CAContext.js';
import { chatButtonConflictingPosition } from './src-config-miaw-button-position.js';
import { t } from './src-utils-translations.js';
import './src-components-ChatButton-Chatbutton.styles.scss.js';
import './src-components-ChatButton-ChatButtonPositions.styles.scss.js';
import { getButtonConfig } from './src-utils-chat-chat-button-utils.js';
import { handleProductPages } from './src-utils-chat-product-page-utils.js';
import { handleFilters } from './src-utils-chat-discovery-page.js';
import { CaseDataContext } from './src-contexts-CaseDataContext.js';

const ChatButton = ({ onClick }) => {
  const [showChatButton, setShowChatButton] = useState(false);
  const [conflictingButtonPosition, setConflictingButtonPosition] = useState("");
  const {
    chatState: { unreadMessages, enableChatbot, chatButtonText, chatSession, chatWindow },
    setChatState
  } = useContext(CAContext);
  const {
    state: { pageInfo }
  } = useContext(CaseDataContext);
  const getFormattedUnreadMessageCount = () => {
    if (unreadMessages) {
      if (unreadMessages > 10) {
        return "10+";
      } else {
        return unreadMessages.toString();
      }
    }
    return void 0;
  };
  useEffect(() => {
    setShowChatButton(chatWindow === "minimized");
  }, [chatWindow]);
  useEffect(() => {
    const { enableChat, buttonType } = getButtonConfig();
    if (enableChat && // IF chat is enabled
    buttonType === "inline" && (chatSession === "initial" || chatSession === "endChatSession")) {
      setShowChatButton(false);
    }
  }, [chatSession]);
  const chatButtonHandler = useCallback((action) => {
    if (action === "show") {
      setShowChatButton(true);
    } else if (action === "hide") {
      setShowChatButton(false);
    }
  }, []);
  useEffect(() => {
    const pageURL = window.location.href;
    chatButtonConflictingPosition.forEach((item) => {
      if (pageURL.includes(t(item.pageName))) {
        setConflictingButtonPosition(item.className);
      }
    });
    handleFilters();
    setTimeout(() => {
      handleProductPages(pageInfo?.pageName || "");
    }, 5e3);
  }, []);
  useEffect(() => {
    setChatState((prevState) => ({
      ...prevState,
      chatButtonHandler
    }));
  }, [chatButtonHandler]);
  if (showChatButton === false) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      className: `caHelpButton ${conflictingButtonPosition}`,
      iconPosition: "left",
      compactMode: true,
      onClick,
      id: `caHelpButton`
    },
    unreadMessages ? unreadMessages > 0 && /* @__PURE__ */ React.createElement(
      Count,
      {
        style: {
          top: "-8px",
          position: "absolute",
          right: "-11px"
        },
        skin: "alert"
      },
      getFormattedUnreadMessageCount() || ""
    ) : null,
    chatSession === "miawChatSession" ? /* @__PURE__ */ React.createElement(Box, { className: "chatButtonActiveIcon" }) : null,
    /* @__PURE__ */ React.createElement(Icon, { iconType: enableChatbot || chatSession === "chatbotSession" ? "aiSupport" : "liveChat" }),
    chatButtonText
  );
};

export { ChatButton as default };
//# sourceMappingURL=src-components-ChatButton-ChatButton.js.map
